/** Czech counts pick one of three forms: 1, 2–4, and everything else (0
 *  included). Returns the noun only — the caller composes it with the count. */
export function czechPlural(
  count: number,
  forms: { one: string; few: string; many: string },
): string {
  if (count === 1) return forms.one;
  if (count >= 2 && count <= 4) return forms.few;
  return forms.many;
}

export const reservationForms = {
  one: "rezervaci",
  few: "rezervace",
  many: "rezervací",
} as const;

export const offerForms = {
  one: "slevový termín",
  few: "slevové termíny",
  many: "slevových termínů",
} as const;

/** „dvou", „tří", „čtyř", „šesti", „sedmi" — the readings whose opening cluster
 *  the preposition is vocalised for. */
const vocalisedLeadingNumerals = new Set([2, 3, 4, 6, 7]);

/** „šestnácti", „sedmnácti" — the teens whose reading opens with a sibilant,
 *  unlike „patnácti" or „osmnácti" beside them. */
const vocalisedTeens = new Set([16, 17]);

/** „šedesáti" and „sedmdesáti"; every other tens word („dvaceti", „třiceti",
 *  „čtyřiceti", „padesáti", „osmdesáti", „devadesáti") takes the bare
 *  preposition. */
const vocalisedTens = new Set([6, 7]);

/** Czech vocalises „z" to „ze" to break a consonant cluster, and which cluster
 *  a numeral opens with depends on how it is *read*, not on its digits: 2 is
 *  „dvou" (ze dvou) but 24 is „dvaceti" (z dvaceti), and 100 is „sta" (ze sta)
 *  while 1000 is „tisíce" (z tisíce). */
export function czechFrom(count: number): "z" | "ze" {
  return leadingNumeralIsVocalised(Math.abs(Math.trunc(count))) ? "ze" : "z";
}

function leadingNumeralIsVocalised(count: number): boolean {
  if (count >= 10 && count <= 19) return vocalisedTeens.has(count);
  if (count >= 20 && count <= 99) return vocalisedTens.has(Math.floor(count / 10));
  if (count >= 100 && count <= 199) return true;
  return vocalisedLeadingNumerals.has(leadingDigit(count));
}

function leadingDigit(count: number): number {
  return Number(String(count)[0]);
}

/** The occupancy line on the slevový termín list — the day header and the rows under it.
 *  „Obsazeno", never „prodáno": the count is every held place, a checkout still
 *  in flight included, which occupies the place without having bought it. */
export function occupancySentence(occupied: number, capacity: number): string {
  return `${occupied} ${czechFrom(capacity)} ${capacity} míst obsazeno`;
}

export const seatForms = {
  one: "místo",
  few: "místa",
  many: "míst",
} as const;
